function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22 7.99999C27.52 7.99999 32 12.48 32 18C32 19.02 31.8 20 31.52 20.92L37.64 27.04C40.42 24.58 42.62 21.5 44 17.98C40.54 9.21998 32 2.99999 22 2.99999C19.46 2.99999 17.02 3.39999 14.72 4.13999L19.06 8.47998C20 8.19998 20.98 7.99999 22 7.99999ZM3.42 1.31999C2.64 2.09999 2.64 3.35999 3.42 4.13999L7.36 8.07999C4.12 10.66 1.54 14.06 0 18C3.46 26.78 12 33 22 33C25.04 33 27.94 32.4 30.62 31.36L36.06 36.8C36.84 37.58 38.1 37.58 38.88 36.8C39.66 36.02 39.66 34.76 38.88 33.98L6.26 1.31999C5.48 0.539985 4.2 0.539985 3.42 1.31999ZM22 28C16.48 28 12 23.52 12 18C12 16.46 12.36 15 12.98 13.72L16.12 16.86C16.06 17.22 16 17.6 16 18C16 21.32 18.68 24 22 24C22.4 24 22.76 23.94 23.14 23.86L26.28 27C24.98 27.64 23.54 28 22 28ZM27.94 17.34C27.64 14.54 25.44 12.36 22.66 12.06L27.94 17.34Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAway);
export default __webpack_public_path__ + "static/media/user-away.612dbd74a1407f8b755b745f466f4350.svg";
export { ForwardRef as ReactComponent };